export const SCOUT_PRIVATE_DOCUMENT_URL_PREFIX = "encamp-private-document://";

/** Persisted on user messages that start monitoring full PDF extraction in-thread. */
export const SCOUT_PRIVATE_DOCUMENT_EXTRACTION_WATCH_URL_PREFIX =
  "encamp-private-document-extraction://";

/** Legacy persisted parts from the Document-table prototype */
export const SCOUT_LEGACY_DOCUMENT_URL_PREFIX = "encamp-document://";

export function buildScoutPrivateDocumentPartUrl(privateDocumentId: string): string {
  return `${SCOUT_PRIVATE_DOCUMENT_URL_PREFIX}${privateDocumentId}`;
}

export function buildScoutPrivateDocumentExtractionWatchPartUrl(privateDocumentId: string): string {
  return `${SCOUT_PRIVATE_DOCUMENT_EXTRACTION_WATCH_URL_PREFIX}${privateDocumentId}`;
}

export function parseScoutPrivateDocumentIdFromPartUrl(
  url: string | null | undefined
): string | undefined {
  if (!url) {
    return undefined;
  }
  if (url.startsWith(SCOUT_PRIVATE_DOCUMENT_EXTRACTION_WATCH_URL_PREFIX)) {
    const id = url.slice(SCOUT_PRIVATE_DOCUMENT_EXTRACTION_WATCH_URL_PREFIX.length);
    return id.length > 0 ? id : undefined;
  }
  if (url.startsWith(SCOUT_PRIVATE_DOCUMENT_URL_PREFIX)) {
    const id = url.slice(SCOUT_PRIVATE_DOCUMENT_URL_PREFIX.length);
    return id.length > 0 ? id : undefined;
  }
  if (url.startsWith(SCOUT_LEGACY_DOCUMENT_URL_PREFIX)) {
    const id = url.slice(SCOUT_LEGACY_DOCUMENT_URL_PREFIX.length);
    return id.length > 0 ? id : undefined;
  }
  return undefined;
}

export function isScoutPrivateDocumentExtractionWatchPartUrl(
  url: string | null | undefined
): boolean {
  return url?.startsWith(SCOUT_PRIVATE_DOCUMENT_EXTRACTION_WATCH_URL_PREFIX) ?? false;
}
